import React, { useState } from 'react';
import Select, { MultiValue } from 'react-select';
import {useAdminContext} from "../../contexts/AdminContext"

interface Option {
  value: string;
  label: string;
}

interface ComboBoxMultipleProps {
    userId: string;
    setBoatIds: (boatIds: string[]) => void;
}


const ComboBoxMultiple: React.FC<ComboBoxMultipleProps> = ({userId, setBoatIds}) => {

  const {tabIdBoats, tabIdUser2Boat} = useAdminContext();

  const options = Object.entries(tabIdBoats).map(([boatId, boatInfo]) => {
    return {value: boatId, label: boatInfo.code};
  }).sort((a:Option, b:Option) => a.label.localeCompare(b.label));

  const initialOptions: Option[] = [];
  if(tabIdUser2Boat){
    for(let key of tabIdUser2Boat[userId]){
        initialOptions.push({value: key, label: tabIdBoats[key].code});
    }
  }
 
  const [selectedOptions, setSelectedOptions] = useState<MultiValue<Option>>(initialOptions);

  const handleChange = (selected: MultiValue<Option>) => {
    setSelectedOptions(selected);
    const boatIds = selected.map(boatInfo =>{return boatInfo.value;})
    setBoatIds(boatIds);
  };

  return (
    <div className="align-items-center g-3">
        <Select
            options={options}
            value={selectedOptions}
            onChange={handleChange}
            isMulti 
            placeholder="Séléctionner bateau(x) ..."
            className="mb-3"
        />
    </div>
  );
};

export default ComboBoxMultiple;
